import type { ReactNode } from 'react';
import { RotateCcw } from 'lucide-react';
import styles from './EditorSlider.module.css';

interface EditorSliderProps {
  icon?: ReactNode;
  label: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  defaultValue?: number;
  formatValue?: (v: number) => string;
  onChange: (v: number) => void;
  onPointerDown?: () => void;
  onPointerUp?: () => void;
}

export function EditorSlider({
  icon,
  label,
  min,
  max,
  step = 1,
  value,
  defaultValue = 0,
  formatValue,
  onChange,
  onPointerDown,
  onPointerUp,
}: EditorSliderProps) {
  const isModified = value !== defaultValue;
  const display = formatValue ? formatValue(value) : String(value);

  return (
    <div className={styles.row}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.label}>{label}</span>
      <div className={styles.sliderWrap}>
        <input
          type="range"
          className={styles.slider}
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          onPointerDown={onPointerDown}
          onPointerUp={onPointerUp}
        />
      </div>
      <span className={styles.value}>{display}</span>
      <button
        className={`${styles.resetBtn} ${isModified ? styles.resetBtnVisible : ''}`}
        onClick={() => onChange(defaultValue)}
        title="Reset"
        type="button"
      >
        <RotateCcw size={12} />
      </button>
    </div>
  );
}
